import { createSlice } from "@reduxjs/toolkit";

const initialState = { sort: "", filter: "", search: "" };

const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    sortReducer: (state, action) => {
      state.sort = action.payload;
    },
    filterReducer: (state, action) => {
      state.filter = action.payload;
    },
    searchReducer: (state, action) => {
      state.search = action.payload;
    },
  },
});

export default filterSlice.reducer;
export const { sortReducer, filterReducer, searchReducer } =
  filterSlice.actions;
